/* eslint-disable prefer-object-spread */
import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../data/axiosInstance/axiosInstance";
import executor from "../../../data/axiosInstance/executor";
import moment from "moment";

import fetchDomainsJson from "./DataQualitySlice.fetchDomains.json";
import fetchVersionInfoJson from "./DataQualitySlice.fetchVersionInfo.json";
import fetchVersionDqListJson from "./DataQualitySlice.fetchVersionDqList.json";
import fetchExtendedStatsJson from "./DataQualitySlice.fetchExtendedStats.json";
import fetchKQIJson from "./DataQualitySlice.fetchKQI.json";
import fetchVersionsListJson from "./DataQualitySlice.fetchVersionsList.json";
import fetchVersionStatusesJson from "./DataQualitySlice.fetchVersionStates.json";

import fetchOwnersJson from "./DataQualitySlice.fetchOwners.json";
import fetchDataCatalogJson from "./DataQualitySlice.fetchDataCatalog.json";
import fetchAssetDataCatalogJson from "./DataQualitySlice.fetchAssetDataCatalog.json";
import fetchAttributesDataCatalogJson from "./DataQualitySlice.fetchAttributesDataCatalog.json";

import { getUserInfo } from "../../../msalInstance";

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

const toError = (reason, fallbackMessage) => {
  if (reason instanceof Error) {
    return reason;
  }

  const message =
    reason?.msgDesc ||
    reason?.message ||
    reason?.response?.data?.msgDesc ||
    reason?.response?.data?.message ||
    fallbackMessage ||
    "Unexpected error";

  const error = new Error(message);
  if (reason && typeof reason === "object") {
    Object.assign(error, reason);
  }
  return error;
};

const initialState = {
  dataCheck: false,
  loading: false,
  loadingCount: 0,
  refreshCount: 0,
  filterIntervallo: 24, // ultime 24 ore
  filterMese: 0, // mese corrente
  filterDataDa: moment().subtract(24, "hours").format("YYYY-MM-DD HH:mm:ss"),
  // filterDataDa: '2023-09-01 00:00:00',
  filterDataA: moment().format("YYYY-MM-DD HH:mm:ss"),
  filterDomains: [],
  filterQuery: [],
  filterDimensions: [],
  filterExtendedStatsDomains: [],
  filterOtherVersion: {},
  domains: [],
  primaryStats: [],
  extendedStats: [],
  kqi: [],
  kqiToDisplay: [],
  versionsList: [],
  versionInfo: [],
  duplicatedVersionInfo: [],
  versionValidationHistory: [],
  versionDqList: [],
  versionsStatuses: [],
  payloadStructure: [],
  summaryStructure: [],
  payload: [],
  dimensions: [],
  summary: [],
  summaryCounts: [],
  checkSummary: false,
  extendedStatsDomains: [],
  versionsCount: 0,
  visiblesIds: 99,
  waterFall: [],
  alertValues: {
    isOpen: false,
    message: "",
    type: "",
    requestId: "",
    clickable: false,
  },
  otherVersions: [],
  comparedVersions: [],
  keys: [],
  filterKeys: {},
  keyChanges: [],
  versionDownloaded: null,
  fileDownloading: false,
  downloadedFile: null,
  dataProducts: [],
  filterDataProducts: [],
  userInitial: "R",
  versionLineage: [],
  dataLineage: [],
  canBeReExecuted: true,

  owners: [],
  filterOwner: "",

  delegates: [],
  nonLinkedDelegates: [],

  fullTextSearch: "",
  isCompleteSearch: false,

  dataCatalog: [],
  dataCatalogOwnership: [],
  dataCatalogSingle: {},
  assetDataCatalog: [],
  distinctProductMetadata: [],
  attributesDataCatalog: [],
  searchedVersion: {},
  userIsAuthToSeeSingleVersion: false,
};

const USE_API = true;

export const DataQualitySlice = createSlice({
  name: "dataQuality",
  initialState,
  reducers: {
    closeAlert: (state) => {
      state.alertValues.isOpen = false;
    },
    openAlert: (state, action) => {
      state.alertValues.isOpen = true;
      state.alertValues.message = action.payload.message;
      state.alertValues.type = action.payload.type;
      state.alertValues.requestId = action.payload.requestId || "";
      state.alertValues.clickable = action.payload.clickable || false;
      state.alertValues.entityId = action.payload.entityId || "";
    },
    toogleLoading: (state) => {
      state.loading = !state.loading;
    },

    toogleDataCheck: (state, action) => {
      state.dataCheck = action.payload;
    },

    setRefreshCount: (state, action) => {
      state.refreshCount = action.payload;
    },
    setVisiblesIds: (state, action) => {
      state.visiblesIds = action.payload;
    },
    startLoading: (state) => {
      state.loadingCount += 1;
      state.loading = true;

    },

    stopLoading: (state) => {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      state.loading = state.loadingCount > 0;
    },

    setFilterVersionStatus: (state, action) => {
      state.filterVersionStatus = action.payload;
    },

    setFilterDomains: (state, action) => {
      state.filterDomains = action.payload;
    },

    setFilterIntervallo: (state, action) => {
      console.debug("setFilterIntervallo", action.payload);
      state.filterIntervallo = action.payload;
    },
    setFilterMese: (state, action) => {
      state.filterMese = action.payload;
    },

    setFilterDataDa: (state, action) => {
      state.filterDataDa = moment(action.payload).format("YYYY-MM-DD HH:mm:ss");
    },

    setFilterDataA: (state, action) => {
      state.filterDataA = moment(action.payload).format("YYYY-MM-DD HH:mm:ss");
    },

    setFilterDimensions: (state, action) => {
      state.filterDimensions = action.payload;
    },
    setFilterExtendedStatsDomains: (state, action) => {
      state.filterExtendedStatsDomains = action.payload;
    },
    getDomains: (state, action) => {
      state.domains = action.payload;
    },

    getPrimaryStats: (state, action) => {
      state.primaryStats = {
        valid: action?.payload?.find((item) => item.id == 1) || { count: 0 },
        pending: action?.payload?.find((item) => item.id == -1) || { count: 0 },
        invalid: action?.payload?.find((item) => item.id == 0) || { count: 0 },
      };
      console.log(state.primaryStats);
    },

    getExtendedStats: (state, action) => {
      state.extendedStats = action.payload;
    },

    getVersionsStatuses: (state, action) => {
      state.versionsStatuses = action.payload;
    },

    getVersionsList: (state, action) => {
      state.versionsList = action.payload;
    },

    getVersionInfo: (state, action) => {
      state.versionInfo = action.payload;
    },

    getDuplicatedVersionInfo: (state, action) => {
      state.duplicatedVersionInfo = action.payload;
    },

    getVersionDqList: (state, action) => {
      state.versionDqList = action.payload;
    },

    getVersionValidationHistory: (state, action) => {
      state.versionValidationHistory = action.payload;
    },

    getKQI: (state, action) => {
      state.kqi = action.payload;
    },

    getKQItoDisplay: (state, action) => {
      state.kqiToDisplay = action.payload;
    },

    getDimensions: (state, action) => {
      state.dimensions = action.payload;
    },
    getPayloadStructure: (state, action) => {
      state.payloadStructure = action.payload;
    },
    getPayload: (state, action) => {
      let payload = action?.payload?.map((x) => x.row);
      let gridArray = [];

      payload?.forEach((x) => {
        let test = {};
        x.forEach(
          (accumulator) => (test[accumulator.name] = accumulator.value)
        );
        gridArray.push(test);
      });

      state.payload = gridArray;
    },
    getSummary: (state, action) => {
      let summary = action?.payload?.map((x) => x.row);
      let gridArray = [];

      summary?.forEach((x) => {
        let test = {};
        x.forEach(
          (accumulator) => (test[accumulator.name] = accumulator.value)
        );
        gridArray.push(test);
      });

      state.summary = gridArray;
    },
    getSummaryCounts: (state, action) => {
      state.summaryCounts = action.payload?.row;
    },
    getSummaryStructure: (state, action) => {
      state.summaryStructure = action.payload;
    },
    getVersionsCount: (state, action) => {
      state.versionsCount = action.payload;
    },
    getExtendedStatsDomains: (state, action) => {
      state.extendedStatsDomains = action.payload;
    },
    getWaterfall: (state, action) => {
      state.waterFall = action.payload;
    },
    getOtherVersions: (state, action) => {
      state.otherVersions = action.payload;

      if (action.payload && action.payload.length > 0) {
        state.filterOtherVersion = action.payload[0];
      }
    },
    setFilterOtherVersion: (state, action) => {
      state.filterOtherVersion = action.payload;
    },
    getComparedVersions: (state, action) => {
      state.comparedVersions = action.payload;
    },
    getKeys: (state, action) => {
      state.keys = action.payload;

      if (action.payload && action.payload.length > 0) {
        state.filterKeys = action.payload[0];
      }
    },
    setFilterKeys: (state, action) => {
      state.filterKeys = action.payload;
    },
    getKeyChanges: (state, action) => {
      state.keyChanges = action.payload;
    },
    setVersionDownloaded: (state, action) => {
      state.versionDownloaded = action.payload;
    },
    setFileDownloading: (state, action) => {
      state.fileDownloading = action.payload;
    },
    setDownloadedFile: (state, action) => {
      state.downloadedFile = action.payload;
    },

    getDataProducts: (state, action) => {
      state.dataProducts = action.payload;
    },
    setFilterDataProducts: (state, action) => {
      state.filterDataProducts = action.payload;
    },
    setUserInitial: (state, action) => {
      state.userInitial = action.payload;
    },
    getVersionLineage: (state, action) => {
      state.versionLineage = action.payload;
    },
    getDataLineage: (state, action) => {
      state.dataLineage = action.payload;
    },
    setCanBeReExecuted: (state, action) => {
      state.canBeReExecuted = action.payload;
    },
    getOwners: (state, action) => {
      state.owners = action.payload;
    },
    setFilterOwner: (state, action) => {
      state.filterOwner = action.payload;
    },
    getDelegates: (state, action) => {
      state.delegates = action.payload;
    },
    getNonLinkedDelegates: (state, action) => {
      state.nonLinkedDelegates = action.payload;
    },
    getDataCatalog: (state, action) => {
      state.dataCatalog = action.payload;
    },
    getDataCatalogSingle: (state, action) => {
      state.dataCatalogSingle = action.payload;
    },
    getAssetDataCatalog: (state, action) => {
      state.assetDataCatalog = action.payload;
    },
    getAttributesDataCatalog: (state, action) => {
      state.attributesDataCatalog = action.payload;
    },
    setFullTextSearch: (state, action) => {
      state.fullTextSearch = action.payload;
    },
    setIsCompleteSearch: (state, action) => {
      state.isCompleteSearch = action.payload;
    },
    getSearchedVersion: (state, action) => {
      state.searchedVersion = action.payload;
    },
    getDataCatalogOwnership: (state, action) => {
      console.log("getDataCatalogOwnership action", action);
      state.dataCatalogOwnership = action.payload;
    },
    getDistinctProductMetadata: (state, action) => {
      state.distinctProductMetadata = action.payload;
    },
    setUserIsAuthorized: (state, action) => {
      state.userIsAuthToSeeSingleVersion = action.payload;
    },
  }
});

export const {
  setRefreshData,
  setRefreshCount,
  setVisiblesIds,
  closeAlert,
  openAlert,
  toogleLoading,
  toogleDataCheck,
  startLoading,
  stopLoading,
  getDomains,
  getPrimaryStats,
  getExtendedStats,
  getKQI,
  getKQItoDisplay,
  getVersionsList,
  getVersionInfo,
  getDuplicatedVersionInfo,
  getVersionDqList,
  getVersionValidationHistory,
  getVersionsStatuses,
  getExtendedStatsDomains,
  setFilterIntervallo,
  setFilterMese,
  setFilterDomains,
  setFilterDataDa,
  setFilterDataA,
  setFilterVersionStatus,
  setFilterDimensions,
  setFilterExtendedStatsDomains,
  getPayloadStructure,
  getPayload,
  getDimensions,
  getSummary,
  getSummaryCounts,
  getSummaryStructure,
  getVersionsCount,
  getWaterfall,
  getOtherVersions,
  setFilterOtherVersion,
  getComparedVersions,
  getKeys,
  setFilterKeys,
  getKeyChanges,
  setVersionDownloaded,
  setFileDownloading,
  setDownloadedFile,
  getDataProducts,
  setFilterDataProducts,
  setUserInitial,
  getVersionLineage,
  getDataLineage,
  setCanBeReExecuted,
  getOwners,
  setFilterOwner,
  getDelegates,
  getNonLinkedDelegates,
  setFullTextSearch,
  setIsCompleteSearch,
  getDataCatalog,
  getDataCatalogSingle,
  getAssetDataCatalog,
  getAttributesDataCatalog,
  getSearchedVersion,
  getDataCatalogOwnership,
  getDistinctProductMetadata,
  setUserIsAuthorized,
} = DataQualitySlice.actions;

/**
 * chiamata APi per recuperare l'elenco di domini
 * @returns https://docs.google.com/document/d/1NtARovXwT5x6HlsdbQzz7QGrSKjE__wdTpTuKsOfelo/edit
 */
export const fetchDomains = () => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDomains([]));
  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/domain/getDomains`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of domains:  " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
    res?.data?.unshift({
      domainDescription: "All",
      domainName: null,
      domainId: null,
    });
  } else {
    res = fetchDomainsJson;
  }

  console.debug("fetchDomains res", res);

  dispatch(getDomains(res?.data || []));
  return dispatch(stopLoading());
};

/**
 * chiamata APi per recuperare le info su una determinata versione
 * @param {integer} versionId L'id della versione
 * @returns https://drive.google.com/file/d/17Ogb3cfwu-0gq70RBAeCl-H7msjJKM9_/view
 */
export const fetchVersionInfo = (versionId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getVersionInfo({}));
  dispatch(getDuplicatedVersionInfo({}));

  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/info/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of version information: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchVersionInfoJson;
  }

  console.debug("fetchVersionInfo res", res);
  if (res?.data?.replaced_by) {
    // se la versione è duplicata recupero anche le info della versione dalla quale duplica
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/info/${res.data.replaced_by}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    const [dupres, innerErr] = await executor.executeAsync(fetchData);
    if (innerErr) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of duplicated version information: " +
            innerErr?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
    dispatch(getDuplicatedVersionInfo(dupres.data));
  }

  dispatch(getVersionInfo(res?.data || []));
  return dispatch(stopLoading());
};

/**
 * chiamata APi per recuperare l'elenco dei rsultati automatici di una versione
 * @param {integer} versionId L'id della versione
 * @returns https://docs.google.com/document/d/1Ttx5UDLE8GfzwqgryKMebt7ezD2ZAmUDfbdfNtWOKfk/edit?usp=sharing
 */
export const fetchVersionDqList = (versionId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getVersionDqList([]));

  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/dq/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of Data Quality: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchVersionDqListJson;
  }

  console.debug("fetchVersionDqList res", res);
  dispatch(getVersionDqList(res?.data || []));
  return dispatch(stopLoading());
};

/**
 * chiamata APi per recuperare l'elenco dei risultati manuali di una versione
 * @param {integer} versionId L'id della versione
 * @returns https://drive.google.com/file/d/1dA3bEl3Uem5DmrF4Ds657weMK2HGEdng/view?usp=sharing
 */
export const fetchVersionValidationHistory =
  (versionId) => async (dispatch) => {
    dispatch(startLoading());
    dispatch(getVersionValidationHistory([]));

    let res;
    let err;
    if (USE_API) {
      const API_URI_CALL = `${API_URL}/api/v1/portal/versions/validationHistory/${versionId}`;
      const fetchData = async () => axiosInstance.get(API_URI_CALL);
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the retrieval of validation history: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    } else {
      res = fetchVersionDqListJson;
    }

    console.debug("fetchVersionValidationHistory res", res);
    dispatch(getVersionValidationHistory(res?.data || []));
    return dispatch(stopLoading());
  };

/**
 * chiamata API per recuperare l'elenco degli stati delle versioni
 * @param {string YYYY-MM-DD HH:mm:ss} fromDate  La data di partenza
 * @param {string YYYY-MM-DD HH:mm:ss} toDate  La data finale
 * @param {array} domains un elenco di uuid di domini
 * @returns https://drive.google.com/file/d/18yqcIGZU0O4vpwQZwwiLY1RZbVh9Sxke/view?usp=sharing
 */
export const fetchPrimaryStats =
  (fromDate, toDate, domains, dataProducts, extendedStats) =>
    async (dispatch) => {
      dispatch(startLoading());
      console.debug(
        "fetchPrimaryStats " + fromDate + " / " + toDate + " / " + domains
      );
      dispatch(getPrimaryStats([]));

      let res;
      let err;
      if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/versionsStatus`;
        const fetchData = async () =>
          axiosInstance.post(
            API_URI_CALL,
            {
              domanisList: domains || [],
              productList: dataProducts || [],
              extendedStatusList: extendedStats || [],
            },
            {
              params: {
                startDate: fromDate,
                endDate: toDate,
              },
            }
          );
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
          dispatch(
            openAlert({
              message:
                "Error during the retrieval of version information: " +
                err?.response?.headers?.apierror,
              type: "danger",
            })
          );
        }
      } else {
        res = fetchExtendedStatsJson;
      }

      console.debug("fetchPrimaryStats::res", res);
      dispatch(getPrimaryStats(res?.data || []));
      return dispatch(stopLoading());
    };

const buildVersionsPostFetchData = (url, fromDate, toDate, domains, dataProducts, extendedStats) =>
  async () =>
    axiosInstance.post(
      url,
      {
        domainList: domains || undefined,
        productList: dataProducts || [],
        extendedStatusList: extendedStats || [],
      },
      { params: { startDate: fromDate, endDate: toDate } }
    );

/**
 * chiamata APi per recuperare l'elenco degli stati estesi delle versioni
 * @param {string YYYY-MM-DD HH:mm:ss} fromDate  La data di partenza
 * @param {string YYYY-MM-DD HH:mm:ss} toDate  La data finale
 * @param {array} domains un elenco di uuid di domini
 * @returns https://drive.google.com/file/d/1vggznJrJ4exwU2cdwA0Cj6gTGx4er7vE/view?usp=drive_link
 */
export const fetchExtendedStats =
  (fromDate, toDate, domains, dataProducts, extendedStats) =>
    async (dispatch) => {
      dispatch(startLoading());
      console.debug(
        "fetchExtendedStats " + fromDate + " / " + toDate + " / " + domains
      );
      dispatch(getExtendedStats([]));

      let res;
      let err;
      if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/versionsExtendedStatus`;
        const fetchData = buildVersionsPostFetchData(API_URI_CALL, fromDate, toDate, domains, dataProducts, extendedStats);
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
          dispatch(
            openAlert({
              message:
                "Error during the retrieval of extended version information: " +
                err?.response?.headers?.apierror,
              type: "danger",
            })
          );
        }
      } else {
        res = fetchExtendedStatsJson;
      }

      res.data?.sort((item1, item2) => item2.status_id - item1.status_id);

      console.debug("fetchExtendedStats res", res);
      dispatch(getExtendedStats(res?.data || []));
      return dispatch(stopLoading());
    };

/**
 * chiamata API per recuperare i KQI
 * @param {string YYYY-MM-DD HH:mm:ss} fromDate  La data di partenza
 * @param {string YYYY-MM-DD HH:mm:ss} toDate  La data finale
 * @param {array} domains un elenco di uuid di domini
 * @returns https://drive.google.com/file/d/19hhyAMZiYwAShG49Jw_b_qPkFIxMlZl0/view
 */
export const fetchKQI =
  (fromDate, toDate, domains, dataProducts, extendedStats) =>
    async (dispatch) => {
      dispatch(startLoading());
      console.debug("fetchKQI " + fromDate + " / " + toDate + " / " + domains);
      dispatch(getKQI([]));
      let res;
      let err;
      if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/kqi`;
        const fetchData = buildVersionsPostFetchData(API_URI_CALL, fromDate, toDate, domains, dataProducts, extendedStats);
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
          console.log("fetchKQI err", err);
          dispatch(
            openAlert({
              message:
                "Error during the retrieval of KQI information: " +
                err?.response?.headers?.apierror,
              type: "danger",
            })
          );
        }
      } else {
        res = fetchKQIJson;
      }

      console.debug("fetchKQI res", res);
      const ret = res?.data?.reduce((accumulator, item) => {
        if (item.id_parent == null) {
          accumulator.push({
            data: item,
            childs: res.data.filter((child) => child.id_parent == item.id),
          });
        }
        return accumulator;
      }, []);
      const iDsToDisplay = [18, 16, 17, 20, 13, 11, 12, 15, 10, 9, 19, 21];
      const ret2 = [];
      res?.data?.forEach((item) =>
        iDsToDisplay.includes(item.id) ? ret2.push(item) : null
      );

      ret2.sort((a, b) => {
        return iDsToDisplay.indexOf(a.id) - iDsToDisplay.indexOf(b.id);
      });

      console.log("kqiToDisplay", ret2);

      console.debug("fetchKQI ret", ret);
      dispatch(getKQI(ret || []));
      dispatch(getKQItoDisplay(ret2 || []));
      return dispatch(stopLoading());
    };

/**
 * chiamata API per recuperare l'elenco delle versioni di un determinato status
 * @param {string YYYY-MM-DD HH:mm:ss} fromDate  La data di partenza
 * @param {string YYYY-MM-DD HH:mm:ss} toDate  La data finale
 * @param {array} domains un elenco di uuid di domini
 * @returns https://drive.google.com/file/d/19hhyAMZiYwAShG49Jw_b_qPkFIxMlZl0/view
 */
export const fetchVersionsList =
  (fromDate, toDate, domains, status, dataProducts) => async (dispatch) => {
    console.debug(
      "fetchVersionsList " +
      fromDate +
      " / " +
      toDate +
      " / " +
      domains +
      " / " +
      status
    );
    dispatch(startLoading());
    dispatch(getVersionsList([]));
    let res;
    let err;
    if (USE_API) {
      const API_URI_CALL = `${API_URL}/api/v1/portal/versions/list`;
      const fetchData = async () =>
        axiosInstance.post(
          API_URI_CALL,
          {
            domainList: domains || [],
            productList: dataProducts || [],
            extendedStatusList: status || [],
          },
          {
            params: {
              startDate: fromDate,
              endDate: toDate,
            },
          }
        );
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the retrieval of versions list: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    } else {
      res = fetchVersionsListJson;
    }

    console.debug("getVersionsList res", res);
    dispatch(getVersionsList(res?.data || []));
    return dispatch(stopLoading());
  };

/**
 * REQF0106 - Manual validation
 * @param {*} fromDate
 * @param {*} toDate
 * @param {*} domains
 * @param {*} status
 * @returns
 */
export const saveManualVersion =
  (check, outcome, note, versionId, file, replacedVersionId, key) =>
    async (dispatch) => {
      console.debug("saveManualVersion");
      dispatch(startLoading());

      const normalizedOutcome =
        outcome === true || outcome === 1 || outcome === "1" || outcome === "true";

      const userInfo = getUserInfo();


      const formData = new FormData();

      formData.append("file", file);

      if (USE_API) {
        let API_URI_CALL = `${API_URL}/api/v1/portal/versions/saveManualVersion`;

        // Wrap the axios call in a Promise
        return new Promise((resolve, reject) => {
          axiosInstance
            .post(API_URI_CALL, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              params: {
                outcome: normalizedOutcome ? 1 : 0,
                note: note,
                versionId: versionId,
                replacedVersionId: replacedVersionId,
                key: key,
                user: userInfo.email,
                checkMode: check,
              },
            })
            .then((response) => {
              if (response.data?.esito) {
                resolve(response.data);
                return;
              }

              reject(
                toError(response.data, "Unexpected error during saving")
              );
            })
            .catch((error) => {
              if (!check) {
                const saveErrorMessage =
                  error?.response?.data?.msgDesc ||
                  error?.response?.data?.message ||
                  error?.msgDesc ||
                  error?.message ||
                  "Unexpected error during saving";
                dispatch(
                  openAlert({
                    message: "Error during saving: " + saveErrorMessage,
                    type: "danger",
                  })
                );
              }
              reject(toError(error, "Unexpected error during saving"));
            })
            .finally(() => {
              dispatch(stopLoading());
            });
        });
      }
    };

export const fetchPayload = (versionId) => async (dispatch) => {
  console.debug("fetchPayload ");
  dispatch(startLoading());
  dispatch(getPayload([]));
  let res = null;
  let err = null;
  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/payload/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of payload: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchVersionStatusesJson;
  }

  console.debug("fetchPayload res", res);
  dispatch(getPayload(res.data));
  return dispatch(stopLoading());
};
export const fetchDimensions = (versionId) => async (dispatch) => {
  console.debug("fetchDimensions ");
  dispatch(startLoading());
  dispatch(getDimensions([]));
  let res = null;
  let err = null;
  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/dimensions/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of dimensions: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchVersionStatusesJson;
  }

  console.debug("fetchDimensions res", res);
  dispatch(getDimensions(res.data));
  return dispatch(stopLoading());
};
export const fetchSummary = (versionId, dimensions) => async (dispatch) => {
  console.debug("fetchSummary ");
  dispatch(startLoading());
  dispatch(getSummary([]));
  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/summary/${versionId}`;
    const fetchData = async () =>
      axiosInstance.post(API_URI_CALL, { values: dimensions });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of summary: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    console.log("non chiamo summary perchè dimension = 0");
  }

  console.debug("fetchSummary res", res);
  dispatch(getSummary(res.data));
  return dispatch(stopLoading());
};

export const fetchPayloadStructure =
  (versionId, dimensions) => async (dispatch) => {
    console.debug("fetchPayloadStructure ");
    dispatch(startLoading());
    dispatch(getPayloadStructure([]));
    let res = null;
    let err = null;
    if (USE_API) {
      let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/payloadStructure/${versionId}`;
      const fetchData = async () => axiosInstance.get(API_URI_CALL);
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the retrieval of Payload Structure: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    }
    console.debug("fetchPayloadStructure res", res);
    dispatch(getPayloadStructure(res.data));
    return dispatch(stopLoading());
  };

export const fetchSummaryStructure =
  (versionId, dimensions) => async (dispatch) => {
    console.debug("fetchSummaryStructure ");
    dispatch(startLoading());
    dispatch(getSummaryStructure([]));
    let res = null;
    let err = null;

    if (USE_API) {
      let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/summaryStructure/${versionId}`;
      const fetchData = async () =>
        axiosInstance.post(API_URI_CALL, {
          values: dimensions.map((x) => x.id),
        });
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the retrieval of Summary Structure: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    } else {
      console.log("non chiamo summary perchè dimension = 0");
    }

    console.debug("fetchSummaryStructure res", res);
    dispatch(getSummaryStructure(res.data));
    return dispatch(stopLoading());
  };
export const fetchVersionsCount =
  (fromDate, toDate, domains, dataProducts, extendedStats) =>
    async (dispatch) => {
      console.debug("DataQualityStatus::fetchVersionsCount");
      dispatch(startLoading());
      dispatch(getVersionsCount([]));

      let res = null;
      let err = null;
      if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/count`;
        const fetchData = async () =>
          axiosInstance.post(
            API_URI_CALL,
            {
              domainList: domains || [],
              productList: dataProducts || [],
              extendedStatusList: extendedStats || [],
            },
            {
              params: {
                startDate: fromDate,
                endDate: toDate,
              },
            }
          );
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
          dispatch(
            openAlert({
              message:
                "Error during the retrieval of versions count: " +
                err?.response?.headers?.apierror,
              type: "danger",
            })
          );
        }
      } else {
        res = {};
      }
      dispatch(getVersionsCount(res?.data || 0));
      return dispatch(stopLoading());
    };

export const fetchExtendedStatsDomains = () => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getExtendedStatsDomains([]));
  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/extStatusDomain`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of States: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
    res?.data?.unshift({ name: "Tutti", status_name: null, id: null });
  }

  console.debug("fetchDomains res", res);

  dispatch(getExtendedStatsDomains(res?.data || []));
  return dispatch(stopLoading());
};

export const fetchSummaryCounts = (versionId) => async (dispatch) => {
  console.debug("fetchSummaryCounts ");
  dispatch(startLoading());
  dispatch(getSummaryCounts([]));
  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/summaryCount/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of Summary Count: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    console.log("non chiamo summary perchè dimension = 0");
  }

  console.debug("fetchSummaryCounts res", res);
  dispatch(getSummaryCounts(res.data));
  return dispatch(stopLoading());
};

export const fetchWaterfall =
  (fromDate, toDate, domains, dataProducts, extendedStats) =>
    async (dispatch) => {
      console.log("fetchWaterfall " + fromDate + " / " + toDate);
      dispatch(startLoading());
      dispatch(getWaterfall([]));
      let res = null;
      let err = null;
      if (USE_API) {
        const API_URI_CALL = `${API_URL}/api/v1/portal/versions/waterfall`;
        const fetchData = buildVersionsPostFetchData(API_URI_CALL, fromDate, toDate, domains, dataProducts, extendedStats);
        [res, err] = await executor.executeAsync(fetchData);
        if (err) {
          dispatch(
            openAlert({
              message:
                "Error during the retrieval of Waterfall: " +
                err?.response?.headers?.apierror,
              type: "danger",
            })
          );
        }
      }

      let ret = [];

      const keys = [
        "processRuns",
        "automaticControls",
        "validationTypes",
        "dataProducts",
      ];

      keys.forEach((key) => {
        if (res?.data[key]) {
          ret.push(res.data[key]);
        }
      });

      console.log("getWaterfall res", ret);
      dispatch(getWaterfall(ret || []));
      return dispatch(stopLoading());
    };

export const attachmentDownload =
  (versionId, oid, name) => async (dispatch) => {
    console.log("attachmentDownload");
    dispatch(startLoading());
    let res = null;
    let err = null;

    if (USE_API) {
      const API_URI_CALL = `${API_URL}/api/v1/portal/versions/downloadVersionAttachment`;
      const fetchData = async () =>
        axiosInstance.get(API_URI_CALL, {
          responseType: "blob",
          params: {
            versionId: versionId,
            attachmentOid: oid,
          },
        });
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the download of the file: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    }

    const href = URL.createObjectURL(res.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", name); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    link.remove();
    URL.revokeObjectURL(href);

    console.log("attachmentDownload res", res);
    dispatch(stopLoading());
  };

export const fetchOtherVersions = (versionId) => async (dispatch) => {
  console.debug("fetchOtherVersions ");
  dispatch(startLoading());
  dispatch(getOtherVersions([]));
  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/otherVersions/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of other versions: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchOtherVersions res", res);
  dispatch(getOtherVersions(res?.data || []));
  return dispatch(stopLoading());
};

export const fetchCompareDimension =
  (versionId, otherVersionId) => async (dispatch) => {
    console.debug("fetchCompareVersions ");
    dispatch(startLoading());
    dispatch(getComparedVersions([]));
    let res = null;
    let err = null;

    if (USE_API) {
      let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/compareDimensions`;
      const fetchData = async () =>
        axiosInstance.get(API_URI_CALL, {
          params: {
            versionIdLatest: versionId,
            versionIdPrevious: otherVersionId,
          },
        });
      [res, err] = await executor.executeAsync(fetchData);
      if (err) {
        dispatch(
          openAlert({
            message:
              "Error during the retrieval of comparison: " +
              err?.response?.headers?.apierror,
            type: "danger",
          })
        );
      }
    }

    console.debug("fetchCompareVersions res", res);
    dispatch(getComparedVersions(res?.data || []));
    return dispatch(stopLoading());
  };

export const fetchKeys = (versionId) => async (dispatch) => {
  console.debug("fetchKeys ");
  dispatch(startLoading());
  dispatch(getKeys([]));
  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/keys/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of keys: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  let ret = [];

  if (res?.data && res?.data.length > 0) {
    ret = res.data.map((item, index) => {
      return {
        id: index,
        name: item,
        obj: JSON.parse(item),
      };
    });
  }

  console.debug("fetchKeys res", res);
  dispatch(getKeys(ret));
  return dispatch(stopLoading());
};

export const fetchKeyChanges = (versionId, key) => async (dispatch) => {
  console.debug("fetchKeyChanges ");
  dispatch(startLoading());
  dispatch(getKeyChanges([]));
  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/keyChangeHistory`;
    const fetchData = async () =>
      axiosInstance.post(API_URI_CALL, key.name, {
        params: {
          versionId: versionId,
        },
        headers: {
          // Overwrite Axios's automatically set Content-Type
          "Content-Type": "application/json",
        },
      });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of keys: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchKeyChanges res", res);
  dispatch(getKeyChanges(res?.data || []));
  return dispatch(stopLoading());
};
export const submitTicket = (data) => async (dispatch) => {
  console.debug("submitTicket start");
  dispatch(startLoading());

  const userInfo = getUserInfo();


  const formData = new FormData();

  formData.append("file", data.file);

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/forMe/genericRequest`;

    // Wrap the axios call in a Promise
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(API_URI_CALL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            templateCode: data.templateCode,
            utente: userInfo.email,
            subject: data.subject,
            note: data.note,
          },
        })
        .then((response) => {
          if (response.data?.esito) {
            dispatch(
              openAlert({
                message:
                  "Ticket opened successfully. Ticket No: " +
                  response?.data?.ticketNum,
                type: "info",
              })
            );
            resolve(response.data);
          }
          // Resolve with the response data
          else throw toError(response.data, "Unexpected error during ticket opening");
        })
        .catch((error) => {
          const normalizedError = toError(
            error,
            "Unexpected error during ticket opening"
          );
          dispatch(
            openAlert({
              message:
                "Error during the opening of the ticket: " +
                normalizedError.message,
              type: "danger",
            })
          );
          console.error("Submit Ticket error:", normalizedError);
          reject(normalizedError);
        })
        .finally(() => {
          dispatch(stopLoading());
        });
    });
  }
};

export const exportPayload = (versionId) => async (dispatch, getState) => {
  console.debug("exportPayload start");

  if (getState().dataQualityReducer.downloadedFile) {
    dispatch(
      openAlert({
        message:
          "Warning, a download process is still in progress, please wait.",
        type: "danger",
      })
    );
    return;
  }

  const versionInfo = getState().dataQualityReducer.versionInfo;

  console.log("VersionInfo", versionInfo);

  dispatch(
    openAlert({
      message: "File Requested, download in progress...",
      type: "info",
    })
  );

  dispatch(setFileDownloading(true));
  dispatch(
    setVersionDownloaded({
      versioneID: versionId,
      versioneProdotto: versionInfo?.product_name,
      versioneData: moment(versionInfo.reference_date).format("DD/MM/YYYY"),
    })
  );

  let res = null;
  let err = null;

  if (USE_API) {
    let API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/payloadExport/${versionId}`;
    const fetchData = async () =>
      axiosInstance.get(API_URI_CALL, {
        responseType: "blob",
      });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the export of the payload: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
      return;
    }

    const fileUrl = URL.createObjectURL(res.data);

    dispatch(
      setDownloadedFile({
        url: fileUrl,
        fileName: res.headers.filename
          ? res.headers.filename
          : "gridExport.csv",
      })
    );
    console.log("exportPayload res", res);
  }
};

export const fetchDataProducts = () => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDataProducts([]));
  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/product/getProducts`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of products: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchDataProducts res", res);

  dispatch(getDataProducts(res?.data || []));
  return dispatch(stopLoading());
}

export const fetchVersionLineage = (versionId, options = {}) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getVersionLineage([]));
  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/versionLineage/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, { params: { optimizeLayout: options.optimizeLayout ? options.optimizeLayout : false, validOnly: options.validOnly ? options.validOnly : false } });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of lineage: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchVersionLineage res", res);
  dispatch(getVersionLineage(res?.data || []));
  return dispatch(stopLoading());
}

export const fetchDataLineage = (productTypeId, options = {}) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDataLineage([]));
  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/dataLineage/${productTypeId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, { params: { optimizeLayout: options.optimizeLayout ? options.optimizeLayout : false } });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of lineage: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchDataLineage res", res);
  dispatch(getDataLineage(res?.data || []));
  return dispatch(stopLoading());
}

export const reExecuteControls = (versionId) => async (dispatch) => {

  dispatch(startLoading());
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/refreshDataQuality/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the re-execution of controls: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
      dispatch(setCanBeReExecuted(false));
    } else {
      dispatch(
        openAlert({
          message: "New controls are being executed",
          type: "info",
        })
      );
    }
  }

  dispatch(stopLoading());

}

export const fetchOwners = () => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getOwners([]));
  let res = null;
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getDataCatalogGetAllDelegatesOrOwners`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error while retrieving owners and delegates: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchOwnersJson;
  }
  console.debug("fetchOwners res", res);
  dispatch(getOwners(res?.data || []));
  return dispatch(stopLoading());
}


export const fetchDataCatalog = (filterDataProducts, filterOwner, fullTextSearch, isCompleteSearch) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDataCatalog([]));
  let res = null;
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getDataCatalogTypesByUsersProductAndFulltext`;

    // Prepare request payload
    const requestBody = {
      user: filterOwner === "All" ? "" : filterOwner || "",
      productIds: filterDataProducts || [],
      fullText: fullTextSearch || "",
      isExtendedSearch: isCompleteSearch || false,
      extendedSearch: isCompleteSearch || false,
      numAttrTooltip: 5
    };

    const fetchData = async () => axiosInstance.post(API_URI_CALL, requestBody);
    [res, err] = await executor.executeAsync(fetchData);

    if (err) {
      dispatch(
        openAlert({
          message: "Error during the retrieval of the data catalog: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchDataCatalogJson;
  }

  console.debug("fetchDataCatalog res", res);
  dispatch(getDataCatalog(res?.data || []));
  return dispatch(stopLoading());
};


export const fetchDataCatalogById = (typeId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDataCatalogSingle({}));
  let res = null;
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getDataCatalogTypesByTypeId`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      params: { typeId: typeId }
    });

    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message: "Error during the retrieval of the data catalog: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchDataCatalogJson;
    console.debug("fetchDataCatalogById res", res);
    dispatch(getDataCatalogSingle(res?.data[0] || []));
    return dispatch(stopLoading());
  }

  console.debug("fetchDataCatalogById res", res);
  dispatch(getDataCatalogSingle(res?.data[0] || {}));
  return dispatch(stopLoading());
};

export const fetchAssetDataCatalog = (typeId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getAssetDataCatalog([]));
  let res = null;
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getDataCatalogAssetsByTypeId`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      params: { typeId: typeId, assetOnly: true }
    });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of assets: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchAssetDataCatalogJson;
  }

  console.debug("fetchAssetDataCatalog res", res);
  dispatch(getAssetDataCatalog(res?.data || []));
  return dispatch(stopLoading());

};

export const fetchAttributeDataCatalog = (typeId, fullTextSearch, isExtendedSearch) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getAttributesDataCatalog([]));
  let res = null;
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getDataCatalogAttributesByTypeId`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL,
      {
        params: { typeId: typeId, fullText: fullTextSearch, isExtendedSearch: isExtendedSearch }
      }
    );
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of attributes: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchAttributesDataCatalogJson;
  }
  console.debug("fetchAttributeDataCatalog res", res);
  dispatch(getAttributesDataCatalog(res?.data || []));
  return dispatch(stopLoading());
};
export const fetchVersionFromSearch = (versionId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getSearchedVersion({}));


  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/versions/info/${versionId}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during the retrieval of version information: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  } else {
    res = fetchVersionInfoJson;
  }

  console.debug("fetchVersionFromSearch res", res);

  dispatch(getSearchedVersion(res?.data || []));
  return dispatch(stopLoading());
};

const fetchDelegateList = async (dispatch, { typeId, apiPath, clearAction, setAction, errorMessage, debugLabel }) => {
  dispatch(startLoading());
  dispatch(clearAction([]));
  let res = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}${apiPath}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, { params: { typeId } });
    const [data, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: errorMessage + err?.response?.headers?.apierror, type: "danger" }));
    } else {
      res = data;
    }
  }

  console.debug(debugLabel, res);
  dispatch(setAction(res?.data || []));
  return dispatch(stopLoading());
};

export const fetchDelegatesDataCatalog = (typeId) => async (dispatch) =>
  fetchDelegateList(dispatch, {
    typeId,
    apiPath: "/api/v1/portal/dataCatalog/getUserRoleByTypeId",
    clearAction: getDelegates,
    setAction: getDelegates,
    errorMessage: "Error during delegates retrieval: ",
    debugLabel: "fetchDelegatesDataCatalog res",
  });

export const fetchPossibleDelegates = (typeId) => async (dispatch) =>
  fetchDelegateList(dispatch, {
    typeId,
    apiPath: "/api/v1/portal/dataCatalog/getDataCatalogGetAllDelegatesNotOfTypeId",
    clearAction: getNonLinkedDelegates,
    setAction: getNonLinkedDelegates,
    errorMessage: "Error during possible delegates retrieval: ",
    debugLabel: "fetchPossibleDelegates res",
  });

const mutateDelegateAction = async (dispatch, { typeId, delegateEmail, apiPath, errorMessage, successMessage, onSuccess }) => {
  dispatch(startLoading());
  if (USE_API) {
    const API_URI_CALL = `${API_URL}${apiPath}`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      params: { typeId, user: delegateEmail }
    });
    const [, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: errorMessage + err?.response?.headers?.apierror, type: "danger" }));
    } else {
      dispatch(openAlert({ message: successMessage, type: "success" }));
      onSuccess();
    }
  }
  dispatch(stopLoading());
};

export const addDelegate = (typeId, delegateEmail) => async (dispatch) =>
  mutateDelegateAction(dispatch, {
    typeId,
    delegateEmail,
    apiPath: "/api/v1/portal/dataCatalog/addDelegate",
    errorMessage: "Error during delegate addition: ",
    successMessage: "Delegate successfully added.",
    onSuccess: () => {
      dispatch(fetchPossibleDelegates(typeId));
      dispatch(fetchDelegatesDataCatalog(typeId));
    },
  });

export const deleteDelegate = (typeId, delegateEmail) => async (dispatch) =>
  mutateDelegateAction(dispatch, {
    typeId,
    delegateEmail,
    apiPath: "/api/v1/portal/dataCatalog/removeDelegate",
    errorMessage: "Error during delegate removal: ",
    successMessage: "Delegate successfully removed.",
    onSuccess: () => {
      dispatch(fetchDelegatesDataCatalog(typeId));
    },
  });

export const updateType = (typeId, user, name, description) => async (dispatch) => {

  dispatch(startLoading());
  let err = null;

  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/updateType`;
    const fetchData = async () => axiosInstance.post(API_URI_CALL, {
      typeId: typeId,
      user: user,
      score: 0,
      name: name,
      description: description
    });
    [, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during data catalog type update: " + err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    } else {
      dispatch(
        openAlert({
          message: "Data catalog type successfully updated.",
          type: "success",
        })
      );
      dispatch(fetchDataCatalogById(typeId));
    }

    dispatch(stopLoading());
  }
};

export const updateAttribute = (typeId, user, name, description, attributeId, isPersonal, searchOptions) => async (dispatch) => {
  const { fullTextSearch, isExtendedSearch } = searchOptions ?? {};
  dispatch(startLoading());
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/updateAttribute`;
    const fetchData = async () => axiosInstance.post(API_URI_CALL, {
      typeId: typeId,
      user: user,
      score: 0,
      name: name,
      description: description,
      attributeId: attributeId,
      isPersonal: isPersonal
    });
    [, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error during data catalog attribute update: " + err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    } else {
      dispatch(
        openAlert({
          message: "Data catalog attribute successfully updated.",
          type: "success",
        })
      );
      dispatch(fetchAttributeDataCatalog(typeId, fullTextSearch, isExtendedSearch));
    }
    dispatch(stopLoading());
  }
};


export const fetchTypesWhereImOwenerOrDelegate = () => async (dispatch) => {
  dispatch(startLoading());
  dispatch(getDataCatalogOwnership([]));
  let res = null;
  let err = null;

  const userInfo = getUserInfo();


  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataCatalog/getUserRolesByUsername`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      params: { userName: userInfo.email }
    });
    [res, err] = await executor.executeAsync(fetchData);

    if (err) {
      dispatch(
        openAlert({
          message:
            "Error retrieving user roles: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }

  console.debug("fetchTypesWhereImDelegate res", res);
  dispatch(getDataCatalogOwnership(res?.data || []));
  return dispatch(stopLoading());
};


export const fetchDistinctProductMetadata = (typeId) => async (dispatch) =>
  fetchDelegateList(dispatch, {
    typeId,
    apiPath: "/api/v1/portal/dataCatalog/getDistinctProductMetadata",
    clearAction: getDistinctProductMetadata,
    setAction: getDistinctProductMetadata,
    errorMessage: "Error during the retrieval of distinct product metadata: ",
    debugLabel: "fetchDistinctProductMetadata res",
  });

export const checkUserAuth = (versionId) => async (dispatch) => {
  dispatch(startLoading());
  dispatch(setUserIsAuthorized(false));

  let res = null;
  let err = null;
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/singleVersion/checkUserAuth`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      params: { versionId: versionId }
    });
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(
        openAlert({
          message:
            "Error checking user authorization: " +
            err?.response?.headers?.apierror,
          type: "danger",
        })
      );
    }
  }
  console.debug("checkUserAuth res", res);
  dispatch(setUserIsAuthorized(res?.data || false));
  return dispatch(stopLoading());
};

export default DataQualitySlice.reducer;
